import { Fragment } from "react";
import config from "../../../config.json";

export interface CurrencyLabelProps {
  amount: number;
  showFree?: boolean;
  isSoldOut?: boolean;
}

export const CurrencyLabel = ({
  amount,
  showFree = false,
  isSoldOut = false,
}: CurrencyLabelProps): JSX.Element => {
  const language =
    config[process.env.GATSBY_VM_MARKET]?.VM_MARKET_LOCALE || "en-AU";
  const formatter = new Intl.NumberFormat(language, {
    currency: config[process.env.GATSBY_VM_MARKET]?.VM_CURRENCY_CODE || "AUD",
    style: "currency",
  });

  const value =
    showFree && amount === 0 && !isSoldOut
      ? "FREE"
      : (isSoldOut && amount === 0) ||
        Number.isNaN(amount) ||
        amount === undefined
      ? "$$$"
      : formatter.format(amount);
  return <Fragment>{value}</Fragment>;
};
